import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { DropDownItem } from "../../../models/DropDownItem"
import { getEvdaDepartmentsAgeFilterState } from "../../../redux/selectors/filterSelector"
import CustomDropDownList, { FilterType } from "./customDropDownList"

export type Props={
    differentAges:DropDownItem[],
    onChangeSelection:(selection:DropDownItem)=>void
}

const DepartmentCustomAgeComponent:React.FC<Props>=({differentAges,onChangeSelection})=>{
    const [AgesItems,setItems]=useState<DropDownItem[]>([])
    const AgesFilter =useSelector(getEvdaDepartmentsAgeFilterState)
    const { t } = useTranslation();
    useEffect(()=>{
      if(AgesItems.length===0){
      setItems(differentAges)
      }
    })
    useEffect(()=>{
       setItems(differentAges)
       setItems(current =>
        current.map(obj => {
          if (AgesFilter.customSelectedAge===parseInt(obj.Element.key)) {
            return {...obj, selected:true};
          }
          else{
            return {...obj, selected:false};
          }
        }),
      );
    },[differentAges])
    useEffect(()=>{
      setItems(current =>
        current.map(obj => {
          if (AgesFilter.customSelectedAge===parseInt(obj.Element.key)) {
            return {...obj, selected:true};
          }
          else{
            return {...obj, selected:false};
          }
        }),
      );
    },[AgesFilter.customSelectedAge])
    return (<CustomDropDownList enableTranslate={false} items={AgesItems} emptyField={t('filter_button_other_age')} filterType={FilterType.CustomAge} onSetSelection={onChangeSelection}></CustomDropDownList>)
    
}

export default DepartmentCustomAgeComponent